export const chatbotSagaActionTypes = {
  callSendMessageSaga: "callSendMessageSaga",
  callFetchChatHistorySaga: "callFetchChatHistorySaga",
  callFetchIndividualChatHistorySaga: "callFetchIndividualChatHistorySaga",
};

export const sendMessageSagaAction: (message: string) => {
  type: string;
  message: string;
} = (message) => {
  return {
    type: chatbotSagaActionTypes.callSendMessageSaga,
    message: message,
  };
};

export const fetchChatHistorySagaAction: () => {
  type: string;
} = () => {
  return {
    type: chatbotSagaActionTypes.callFetchChatHistorySaga,
  };
};

export const fetchIndividualChatHistorySagaAction: (conversationSessionId: string) => {
  type: string;
  conversationSessionId: string;
} = (conversationSessionId) => {
  return {
    type: chatbotSagaActionTypes.callFetchIndividualChatHistorySaga,
    conversationSessionId: conversationSessionId,
  };
};
